<template>
  <div style="height:100vh;background:white; ">
    <div :style="{'width':'100%', 'display':'flex','height':'30%' }">
      <div class="div-width" >
        <div style="display:flex;line-height:25px ;  ">
          <div  class="oneMenu" @click="itemClick('one')"  >
            <div style="margin-left:0px;display:flex;min-width:20px" :class="{active: actitem==='one'}" >
              <i class="iconfont icon-dengdaiqueren" style="margin-left:4px;margin-right:5px"></i>我的待办
              <el-link :underline="false" @click="waitList" style="margin-left:10px">
                <el-tooltip content="刷新工作通知记录" effect="light">
                  <i class="iconfont icon-shuaxin1" style="float:right;color:#409eff;font-size:12px;margin-right:4px;"></i>
                </el-tooltip>
              </el-link>
            </div>

          </div>
          <div  class="oneMenu" @click="itemClick('two')">
            <div style="margin-left:40px;min-width:20px" :class="{active: actitem==='two'}" >
              <i class="iconfont icon-yiqueren-xianxing" style="margin-left:4px;margin-right:5px"></i>我已审批【{{okNum}}】</div>
          </div>
          <div  class="oneMenu" @click="itemClick('three')">
            <div style="margin-left:40px;min-width:20px" :class="{active: actitem==='three'}" >
              <i class="iconfont icon-xiaoxi" style="margin-left:4px;margin-right:5px"></i>待跟进任务明细【{{ccNum}}】
            </div>
          </div>
        </div>
        <div v-if="actitem=='two'" :style="{'height':'calc(100% - 30px)' }">
          <el-table  :data="okData"
                     border
                     disabled-hover
                     :row-key="getRowKey"
                     :header-cell-style="{height:'25px'}"
                     header-cell-class-name="clearPadding"
                     :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                     style="overflow:auto;margin-top:1px;"
                     ref="refcfm"
                     height="calc(100% - 35px)"
                     :row-class-name="tabRowClass"
                     v-loading="t_loading"
                     element-loading-text="加载中"
                     element-loading-spinner="el-icon-loading"
                     element-loading-background="rgba(255, 251, 255, 0.8)"
                     class="custom-table-border"
                     highlight-current-row>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column  v-for="(item,index ) in itmCol.filter(item=>item.thide=='N')" :key="index"
                              :prop="item.key"
                              :label="item.title"
                              show-overflow-tooltip
                              :align="item.align"
                              :min-width="item.width">
              <template slot-scope="scope">
                <el-link v-if="item.key=='IDNO2'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                <span v-else v-text ="scope.row[item.key]"></span>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="90">
              <template slot-scope="scope">
                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                <el-link  :underline="false" @click="openApp(scope.row,scope.$index,'OK')" ><span style="font-size:11px;">查看进度 </span></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style=" margin-top:2px;overflow: hidden;display:flex;background:white;font-size:12px ;padding-left:4px">
            <div style="float: left;font-size:12px">
              <Page :total="dataCount" :page-size="pageSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
          </div>
        </div>
        <div v-if="actitem=='three'" :style="{'height':'calc(100% - 30px)', 'overflow-y':'hidden' }" >

          <list-item ref="refwait" ></list-item>

        </div>
        <div v-show="actitem=='one'" :style="{ 'height':'calc(100% - 30px)'}">
          <el-table  :data="taskData"
                     border
                     disabled-hover
                     :row-key="getRowKey"
                     :header-cell-style="{height:'25px'}"
                     header-cell-class-name="clearPadding"
                     :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                     style="overflow:auto;margin-top:1px;"
                     ref="reftask"
                     height="100%"
                     :row-class-name="tabRowClass"
                     v-loading="v_loading"
                     element-loading-text="加载中"
                     element-loading-spinner="el-icon-loading"
                     element-loading-background="rgba(255, 251, 255, 0.8)"
                     class="custom-table-border"
                     highlight-current-row>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column  v-for="(item,index ) in taskCol.filter(item=>item.thide=='N')" :key="index"
                              :prop="item.key"
                              :label="item.title"
                              show-overflow-tooltip
                              :align="item.align"
                              :min-width="item.width">
              <template slot-scope="scope">
                <el-link v-if="item.key=='IDNO'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                <span v-else-if="item.key=='ATTACH'">
                                    <el-link v-if="scope.row['PATH1']" :underline="false" >
                                        <div v-if="scope.row['PATH1'].lastIndexOf('.pdf')>-1 ">
                                            <div @click="imgPreview(scope.row['PATH1'])" slot="error"><i class="iconfont icon-pdf"></i></div>
                                        </div>
                                        <el-image v-else style="width:100%;height:20px;" :src="scope.row['PATH1']" :preview-src-list="[scope.row['PATH1']]">
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    </el-link>
                                    <el-link v-if="scope.row['PATH2']" :underline="false" >
                                        <div v-if="scope.row['PATH2'].lastIndexOf('.pdf')>-1 " style="margin-left:5px" >
                                            <div @click="imgPreview(scope.row['PATH2'])" slot="error"><i class="iconfont icon-pdf"></i></div>
                                        </div>
                                        <el-image v-else style="width:100%;height:20px;margin-left:5px" :src="scope.row['PATH2']" :preview-src-list="[scope.row['PATH2']]">
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    </el-link>
                                    <el-link v-if="scope.row['PATH3']" :underline="false" >
                                        <div v-if="scope.row['PATH3'].lastIndexOf('.pdf')>-1 " style="margin-left:5px" >
                                            <div @click="imgPreview(scope.row['PATH3'])" slot="error"><i class="iconfont icon-pdf"></i></div>
                                        </div>
                                        <el-image v-else style="width:100%;height:20px;margin-left:5px" :src="scope.row['PATH3']" :preview-src-list="[scope.row['PATH3']]">
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    </el-link>
                                </span>
                <span v-else v-text ="scope.row[item.key]"></span>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="70">
              <template slot-scope="scope">
                                <span v-if="scope.row['TY']!=='FREE'">
                                    <!-- <i class="iconfont icon-chakan" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                                    <el-link   :underline="false" @click="cfmRec(scope.row)" ><span style="font-size:11px;margin-right:8px">查看审批</span></el-link> -->
                                    <i class="iconfont icon-chenggong" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                                    <el-link   :underline="false" @click="openApp(scope.row,scope.$index,'N')" ><span style="font-size:11px;">跟进 </span></el-link>
                                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
    <!-- 第二行 -->
    <div style="margin-top:4px" >
      <div style="line-height:28px;margin-top:1px;height:28px;background:#ccc; display:flex">
        <i class="iconfont icon-yuandianxiao" style="color:#ff60af;line-height:28px; "></i>
        <div style="color:black;font-weight:600;font-size:12px">待跟进订单明细 </div>
        <el-link :underline="false" @click="getOrdList" style="margin-left:10px;">
          <el-tooltip content="刷新待跟进记录" effect="light">
            <i class="iconfont icon-shuaxin1" style="float:right;color:#409eff;font-size:14px;margin-right:4px;"></i>
          </el-tooltip>
        </el-link>
      </div>
    </div>
    <div :style="{'width':'100%', 'display':'flex','height':'30%','overflow-y':'auto' }">
      <div :style="{'height':'calc(100% - 2px)',width:'100%'}">
        <el-table  :data="ordData"
                   border
                   disabled-hover
                   :row-key="getOrdKey"
                   header-cell-class-name="clearPadding"
                   :row-class-name="tabRowClass"
                   :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                   :header-cell-style="{height:'25px'}"
                   style="overflow:auto;margin-top:1px;"
                   v-loading="w_loading"
                   element-loading-text="加载中"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(255, 251, 255, 0.8)"
                   default-expand-all
                   :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                   ref="reford"
                   height="100%"
                   class="custom-table-border"
                   highlight-current-row>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="任务单号" prop="idno" :min-width="140" :show-overflow-tooltip="true" align="left" >
            <template slot-scope="scope"><span @click="workList(scope.row['idno'])" style="border-bottom:1px solid red;font-size:11px;cursor:pointer ">{{scope.row['idno']}}</span></template>
          </el-table-column>
          <el-table-column  v-for="(item,index ) in ordCol.filter(item=>item.thide=='N'&&item.key!=='tasktynm'&&item.key!=='idno')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"
                            :min-width="item.width">
            <template slot-scope="scope">
              <el-tag v-if="item.key=='stfg'" size="small" :type='customColorMethod(scope.row[item.key])'  >{{scope.row['stfgnm']}} </el-tag>
              <el-progress v-else-if="item.key=='pct'" :text-inside="true" :stroke-width="22" :percentage="Number(scope.row['pct'])"  style="color:red"></el-progress>
              <span v-else-if="item.key=='stfgnm'">
                                <el-tag v-if="scope.row['stfg']=='NO'" size="mini" type="info" effect="dark">{{scope.row[item.key]}}</el-tag>
                                <el-tag v-else-if="scope.row['stfg']=='OK'" size="mini" type="success" effect="dark">{{scope.row[item.key]}}</el-tag>
                                <el-tag v-else-if="scope.row['stfg']=='PEND'" size="mini" type="primary" effect="dark">{{scope.row[item.key]}}</el-tag>
                                <el-tag v-else size="mini" type="danger" effect="dark">{{scope.row[item.key]}}</el-tag>
                            </span>
              <span v-else v-text ="scope.row[item.key]"></span>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="90">
            <template slot-scope="scope">
              <i class="iconfont icon-jinduchaxun" style="color:#409EFF;font-size:12px;margin-right:5px;font-weight:600"></i>
              <el-link :disabled="!scope.row['refidno']"   @click="processShow(scope.row )" :underline="false"  ><span style="font-size:12px;font-weight:600">查看进度 </span></el-link>
            </template>
          </el-table-column>
        </el-table>

      </div>

    </div>
    <!-- 第三行 -->
    <div style="line-height:28px;margin-top:1px;height:28px;background:#ccc; display:flex">
      <i class="iconfont icon-yuandianxiao" style="color:green;line-height:28px; "></i>
      <div style="color:black;font-weight:600;font-size:12px">待跟进工作明细（与自己相关）</div>
      <el-link :underline="false" @click="getWkList" style="margin-left:10px;">
        <el-tooltip content="刷新待跟进记录" effect="light">
          <i class="iconfont icon-shuaxin1" style="float:right;color:#409eff;font-size:14px;margin-right:4px;"></i>
        </el-tooltip>
      </el-link>
    </div>
    <div :style="{ 'height':'calc(26% - 10px)' }"  >
      <div :style="{'height':'calc(100% - 2px)',width:'100%'}">
        <el-table  :data="wkData.filter(item=>item.TASKTY!=='414831').filter(item=>(item.EMPNO==this.v_username||item.EMPNO2==this.v_username||item.EMPNO3==this.v_username||item.EMPNO4==this.v_username||item.EMPNO5==this.v_username))"
                   border
                   disabled-hover
                   :row-key="getRowKey"
                   header-cell-class-name="clearPadding"
                   :row-class-name="tabRowClass"
                   :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                   :header-cell-style="{height:'25px'}"
                   style="overflow:auto;margin-top:1px;"
                   ref="refwk"
                   v-loading="d_loading"
                   element-loading-text="加载中"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(255, 251, 255, 0.8)"
                   height="100%"
                   class="custom-table-border"
                   highlight-current-row>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column  v-for="(item,index ) in wkCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"
                            :min-width="item.width">
            <template slot-scope="scope">
              <el-link v-if="item.key=='IDNO'" :underline="false" @click="workList(scope.row['IDNO'])"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
              <el-tag v-else-if="item.key=='STFG'" size="small" :type='customColorMethod(scope.row[item.key])'  >{{scope.row['STFGNM']}} </el-tag>
              <el-popover placement="top-start" title="说明" v-else-if="item.key=='TASKTYNM'" width="350" trigger="hover">
                <p style="color:#409eef;font-weight:700;font-size:13px"> {{scope.row['TASKTITLE']}}</p>
                <span slot="reference"><span style="border-bottom:1px solid red">{{scope.row[item.key]}}</span></span>
              </el-popover>
              <el-progress v-else-if="item.key=='PCT'" :text-inside="true" :stroke-width="22" :percentage="Number(scope.row['PCT'])"  style="color:red"></el-progress>
              <span v-else v-text ="scope.row[item.key]"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body>
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
      </div>
      <div style="line-height:30px;display:flex">
        <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
        <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
      </div>
      <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
    </el-dialog>

    <!-- report preview -->
    <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
      </div>
      <div style="height:88vh;overflow-y:auto">
        <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="stfgWin" width="600px" append-to-body>
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">进度状态</span>
      </div>
      <div>
        <el-radio v-model="v_radio" label="NO" border>未开始</el-radio>
        <el-radio v-model="v_radio" label="PEND" border>进行中</el-radio>
        <el-radio v-model="v_radio" label="OK" border>已完成</el-radio>
        <el-radio v-model="v_radio" label="OVER" border>已逾期</el-radio>
      </div>
      <span slot="footer"  >
                <el-button type="info" size="small" @click="stfgWin = false" style="margin-right:40px;">取 消</el-button>
                <el-button type="primary" size="small" @click="stfgSure">确 定</el-button>
            </span>
    </el-dialog>
    <!-- 变更用途 -->
    <el-dialog v-dialogDrag :visible.sync="rmkWin" width="650px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
        <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">提示</span>
      </div>
      <div style="display:flex;line-height:45px" >
        <div style="width:100px;font-size:12px;font-weight:600;color:#389" >驳回原因</div>
        <el-input resize="none" type="textarea" :rows="3"  placeholder="请输入驳回原因" v-model="v_rmk" maxlength="1500" show-word-limit ></el-input>
      </div>

      <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" @click="rmkWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button   @click="redoExit" size="small" type="warning" style="margin-left:50px;" icon="iconfont icon-chexiao_icon"  > 驳回</el-button>
                    <el-button   @click="checkOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-chenggong1"  > 审核</el-button>
                </span>
      </div>
    </el-dialog>
    <!-- 审批流程查看弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="appWin" width="800px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="3vh">
      <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">审批流程进度</span>
      </div>
      <div style="height:75vh;overflow-y:auto;background:#fff;margin-top:-8px">
        <div style="display:flex;line-height:25px ;  ">
          <div  class="oneMenu" @click="tabClick('three')"  >
            <div style="margin-left:0px;display:flex" :class="{active: tabitem==='three'}" >
              <i class="iconfont icon-xinxi" style="margin-left:4px;margin-right:5px"></i>审批信息
            </div>
          </div>
          <div  class="oneMenu" @click="tabClick('four')">
            <div style="margin-left:40px" :class="{active: tabitem==='four'}" >
              <i class="iconfont icon-lishijilu" style="margin-left:4px;margin-right:5px"></i>审批日志</div>
          </div>
        </div>
        <div v-if="tabitem=='four'">
          <div style="background:#f7f8f9; border-radius:4px;margin-top:4px ">
            <div style="display:flex;flex-wrap:wrap;line-height:30px">
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;padding-left:4px">单据类型：</span>
                <span style="color:black;font-weight:600;">{{appRow.IDTY}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;">单据编码：</span>
                <span style="color:black;font-weight:600;">{{appRow.IDNO}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;padding-left:4px">单据日期：</span>
                <span style="color:black;font-weight:600;">{{appRow.ADDDTTM}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;">发起用户：</span>
                <span style="color:black;font-weight:600;">{{appRow.ADDUSER}}</span>
              </div>
            </div>
            <div style="width:100%; line-height:30px">
              <span style="color:#808695;font-size:13px;padding-left:4px">单据描述：</span>
              <span style=" font-weight:600;color:black;">{{appRow.TITLE}}</span>
            </div>
          </div>
          <el-timeline style="margin-top:10px;margin-left:5px">
            <el-timeline-item v-for="(item, index) in logData"
                              :key="index"
                              :color="item.COLOR"
                              size="large"
                              :timestamp="item.APPDTTM" placement="top">
              <el-card>
                <h4>{{item.RMK}}</h4>
                <div style="line-height:30px;margin-top:10px">{{item.TITLE}}</div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div v-if="tabitem=='three'">
          <div style="background:#f7f8f9; border-radius:4px;margin-top:4px ">
            <div style="display:flex;flex-wrap:wrap;line-height:30px">
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;padding-left:4px">单据类型：</span>
                <span style="color:black;font-weight:600;">{{appRow.IDTY}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;">单据编码：</span>
                <span style="color:black;font-weight:600;">{{appRow.IDNO}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;padding-left:4px">单据日期：</span>
                <span style="color:black;font-weight:600;">{{appRow.ADDDTTM}}</span>
              </div>
              <div style="width:50%; ">
                <span style="color:#808695;font-size:13px;">发起用户：</span>
                <span style="color:black;font-weight:600;">{{appRow.ADDUSER}}</span>
              </div>
            </div>
            <div style="width:100%; line-height:30px">
              <span style="color:#808695;font-size:13px;padding-left:4px">单据描述：</span>
              <span style=" font-weight:600;color:black;">{{appRow.TITLE}}</span>
            </div>
          </div>
          <div  class="one-div" style="margin-top:10px;">
            <span class="oneRow"> 跟进信息 </span>
          </div>
          <div style="display:flex;line-height:45px" >
            <div style="width:100px;font-size:12px;font-weight:600;color:#389" >跟进备注</div>
            <el-input resize="none" type="textarea" :rows="3"  placeholder="请输入备注" v-model="v_rmk" maxlength="1500" show-word-limit ></el-input>
          </div>
          <!-- 审批进度时间线 -->
          <div style="margin-top:10px;">
            <div  class="one-div" style="justify-content:space-between">
              <div class="oneRow">
                <i class="iconfont icon-jindu" style="color:#808695"></i> 审批进度
              </div>
            </div>
            <!-- 自定义流程时间线 -->
            <div v-if="timelineData.length > 0" class="custom-timeline">
              <div
                  v-for="(item, index) in timelineData"
                  :key="index"
                  class="timeline-item"
                  :class="{ 'last-item': index === timelineData.length - 1,'cc-to-cc': isCCToCC(index) }">
                <!-- 左侧头像和连接线 -->
                <div class="timeline-left">
                  <div class="avatar-container">
                    <div class="avatar" :class="getAvatarClass(item.status)">
                      <i v-if="item.type === 'start'" class="iconfont icon-yonghu-yuan" style="font-size: 22px;"></i>
                      <i v-else-if="item.type === 'end'" class="el-icon-check"></i>
                      <i v-else-if="item.type === 'cc'" class="el-icon-s-promotion" style="font-size: 22px;"></i>
                      <span v-else class="avatar-text">{{ getAvatarText(item.title) }}</span>
                    </div>
                    <div v-if="item.status === 'success'" class="status-check">
                      <i class="el-icon-check"></i>
                    </div>
                    <!-- 审批中状态的...图标 -->
                    <div v-if="item.status === 'warning'" class="status-processing">
                      <i class="el-icon-more"></i>
                    </div>
                  </div>
                  <div v-if="index < timelineData.length - 1" class="timeline-line"></div>
                </div>
                <!-- 右侧内容 -->
                <div class="timeline-content">
                  <div class="timeline-header">
                    <div class="timeline-title">
                      <span class="role-type">{{ getRoleType(item) }}</span>
                      <span class="role-name">{{ getRoleName(item) }}<span v-if="item.status !== 'info' && item.type !== 'start'" class="status-text" :class="getStatusClass(item.status)">{{ getStatusText(item ) }}</span>
                                            <span  style="margin-left:10px">  {{item.chkrmk}} </span>
                                        </span>
                      <!-- <span class="role-name">{{item.chkrmk}} </span> -->
                    </div>
                    <div class="timeline-time">{{ item.timestamp }}</div>
                  </div>

                  <!-- 进度信息（仅对当前审批中的项目显示） -->
                  <div v-if="item.status === 'warning' && item.progress" class="progress-info">
                    <span class="progress-text">{{ item.progress.text }}</span>
                    <span class="progress-detail">{{ item.progress.detail }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else style="text-align:center;padding:40px;color:#909399;">
              <i class="el-icon-info" style="font-size:48px;margin-bottom:16px;"></i>
              <div style="font-size:16px;">暂无审批流程数据</div>
              <div style="font-size:14px;margin-top:8px;">该文件可能未配置审批流程或流程数据异常</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabitem=='three'">
        <div v-if="v_flag=='N'" style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px;margin-top:20px ">
                    <span style="float:right">
                        <el-button type="info" @click="appWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button :disabled="v_commit"  @click="rmkExit" size="small" type="warning" style="margin-left:50px;" icon="iconfont icon-chexiao_icon"  > 驳回</el-button>
                        <el-button :disabled="v_commit"  @click="rmkOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-chenggong1"  > 同意</el-button>
                    </span>
        </div>
        <div v-if="v_flag=='OK'" style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px;margin-top:20px ">
                    <span style="float:right">
                        <el-button type="info" @click="appWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button :disabled="v_commit"  @click="rmkExit" size="small" type="warning" style="margin-left:50px;" icon="iconfont icon-chexiao_icon"  > 驳回</el-button>
                    </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-image  src="/assets/authorize/loading.gif" ></el-image>
    </el-dialog>
    <ProcessMindMap
        v-if="processWin"
        :visible.sync="processWin"
        :order-row="v_repRow"
        product-mode="multiple"
        :drawer="true"
        :full-height="true"
        :enable-node-add="true"
        :drawer-title="processMindMapTitle">
    </ProcessMindMap>
  </div>
</template>

<script>
import { isNull,getTabColOrData } from '../api/user';
import {getDate } from '../api/Select'
import ProcessMindMap from '@/components/ProcessMindMap/index.vue'
import {handleApproval} from '@/utils/workflowDesigner'
import listItem from './sysmgt/wait_work_pane.vue'
export default {
  name: "Mainpage",
  components: {
    listItem,
    ProcessMindMap,
  },
  mounted () {
    //接收SOCKET 信息
    //this.pushBom()
    this.reFresh() //定时刷新
    if (this.$refs.refwait){
      this.ccNum =this.$refs.refwait.v_rowcnt
    }
    
    
  },
  computed: {
    tabHeight: function() {
      return (window.innerHeight - 620) + 'px';
    },
    tabWidth: function() {
      return (window.innerWidth - 160) + 'px';
    },
    processMindMapTitle: function() {
      const orderNo = (this.v_repRow && (
        this.v_repRow.REFIDNO || this.v_repRow.refidno ||
        this.v_repRow.ORDNO || this.v_repRow.ordno ||
        this.v_repRow.IDNO || this.v_repRow.idno
      )) || ''
      return (orderNo ? orderNo + ' ' : '') + this.$LANG('', '生命周期')
    },
  },
  data(){
    return {
      rmkWin:false,
      perRow:{},
      v_radio:'NO',
      stfgWin:false,
      appWin:false,
      dataCount:0,
      ccCount:0,
      // 每页显示多少条
      pageSize:20,
      v_formnm:'',
      v_year:'',
      processWin:false,
      v_roleid:'',
      appRow: {},
      promptWin:false,
      prompt:'',
      v_commit:false,
      v_url: 'xuper_auth/getBaseData',
      dtlRow:{},
      current:1,
      actitem:'one',
      c_loading:false,
      okAll:[],
      loveItem:[],
      invInstance: null,
      extInstance:null,
      cltInstance:null,
      year:'',
      v_cond:'',
      itmCol:[],
      logData:[],
      ccNum:0,
      okNum:0,
      v_lang:this.$store.state.lang,
      v_username:this.$cookies.get('v_telno'), //api 请求用户
      ordData:[],
      v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
      v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
      timelineData:[],
      okData:[],
      formArr:[],
      v_formurl: 'xuper_auth/getFormGroup',
      wkData:[],
      wkCol:[],
      ordCol:[],
      v_dttm:'',
      v_rmk:'',
      ccAll:[],
      ccData:[],
      rmkArr:[],
      v_row:'',
      v_cfmRow:{},
      v_cfmindex:'',
      v_index:'',
      costArr:[],
      lineData:[],
      v_week:'',
      tabArr:[],
      v_repRow:{},
      v_flag:'N',
      yrArr:[],
      yrArr2:[],
      oper:'like',
      txtparam:'',
      mthData:[],
      mthTask:[],
      oper2:'like',
      loadWin:false,
      tabData:[],
      taskCol:[],
      taskData:[],
      repWin:false,
      repUrl:'',
      w_loading:false,

      t_loading:false,
      tabitem:'three',
      v_loading:false,
      approvalUsers: [],
      approvalLogs: [],
      typeData:[],
      cltData:[],

      d_loading:false,
    }
  },
  created () {
    this.$axios({
        method:'post', 
        url: 'xuper_auth/getBaseData' ,
        data:{p_table:'v_sys_user',p_key:'userno',p_value:this.v_username },
    }).then(res =>{
      this.v_roleid =res.result[0]['ROLENO']
      this.getOrdList()
 
    })
    this.getTabField()
    this.getWkList() //
    //查询数据

    this.waitList()
    
  },
  watch: {

    v_formnm  : function(){
      this.formQry()
    },

  },
  methods:{
    processShow(row){
      const payload = {corpid:this.v_corpid,p_idseq:row['refidno'],p_action:'SALE_MAIN#' ,p_user: this.v_username}
      this.$axios({
        method: 'post',
        url:'/xuper_oss/call_package',
        data: payload,
      }).then(res=>{
        if (res.code!=='200'){
          this.promptWin =true
          this.prompt =res.result
        }else{
          this.v_repRow =JSON.parse(JSON.stringify(row))
          this.processWin =true
        }
      })
    },
    // 判断当前节点到下一个节点是否都是抄送人
    isCCToCC(index) {
      if (index >= this.timelineData.length - 1) {
        return false;
      }

      const currentItem = this.timelineData[index];
      const nextItem = this.timelineData[index + 1];

      // 检查当前节点和下一个节点是否都是抄送人
      const isCurrentCC = currentItem.user && currentItem.user.ISCC === '1';
      const isNextCC = nextItem.user && nextItem.user.ISCC === '1';

      return isCurrentCC && isNextCC;
    },
    // 获取头像样式类
    getAvatarClass(status) {
      return status;
    },
    // 获取头像文字
    getAvatarText(title) {
      // 提取姓名的后两个字符作为头像文字
      if (title.includes('：')) {
        const name = title.split('：')[1];
        if (name=='Carldeng'){
          return '邓总'
        }else if (name && name.length >= 2) {
          return name.slice(-2); // 取后两个字符
        } else if (name && name.length === 1) {
          return name; // 如果只有一个字，直接返回
        }
        return '用户'; // 默认值
      }
      // 如果没有冒号分隔符，直接从title取后两个字符
      if (title.length >= 2) {
        return title.slice(-2);
      }
      return title.charAt(0);
    },
    // 获取状态样式类
    getStatusClass(status) {
      return status;
    },

    // 获取状态文字
    getStatusText(item) {
      switch (item.status) {
        case 'success':
          if (item.type === 'cc'){
            return '(已接收)';
          }else{
            return '(已同意)';
          }
        case 'warning':
          return '(审批中)';
        case 'cc':
          return '(已接收)';
        case 'end':
          return '';
        default:
          return ;
      }
    },
    // 获取角色类型
    getRoleType(item) {
      if (item.type === 'start') {
        return '发起申请';
      } else if (item.type === 'end') {
        return '流程结束';
      } else {
        // 判断是否为抄送人
        if (item.title.includes('抄送人')) {
          return '抄送人';
        } else {
          return '审批人';
        }
      }
    },

    // 获取角色姓名
    getRoleName(item) {
      if (item.type === 'start') {
        // 对于发起人，显示具体的姓名而不是"发起申请"
        // 从title中提取姓名部分
        if (item.title.includes('：')) {
          return item.title.split('：')[1];
        }
        // 如果没有冒号分隔符，直接返回title作为姓名
        return item.title;
      } else if (item.type === 'end') {
        return item.title;
      }
      // // 提取姓名部分
      if (item.title.includes('：')) {
        return item.title.split('：')[1];
      }
      return item.title;
    },
    getOrdKey(row){
      return row.idseq
    },
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '';
      // 格式化时间为 MM.DD HH:mm 格式
      const date = new Date(timestamp);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}.${day} ${hours}:${minutes}`;
    },
    //跟进审批
    openApp(row,index,val){
      if (row['TY']=='FINFEE'){
        this.appRow =JSON.parse(JSON.stringify(row))
        this.v_cfmindex=index
        this.v_cfmRow = JSON.parse(JSON.stringify(row))
        this.v_flag = val
        // 使用文件的IDSEQ作为业务ID查询审批数据  458025 //
        const businessId =row.IDSEQ
        this.appWin =true
        if (val =='Y'){  //只查看
          this.v_rmk =row['CHKRMK']
        }else{
          this.v_rmk =''
        }
        this.$axios({   // 日志记录
          method: 'post',
          url: 'xuper_auth/getBaseData' ,
          data: {p_key: 'IDSEQ',p_value: businessId, p_table:'V_SYS_FLOW_APPLOG' },
        }).then(res=>{
          this.approvalLogs =res.result
          // 审批用户
          this.$axios({
            method: 'post',
            url: 'xuper_auth/getBaseData' ,
            data: {p_key: 'IDSEQ',p_value: businessId, p_table:'v_sys_flow_appuser' },
          }).then(res=>{
            this.approvalUsers =res.result
            // 合并数据创建时间线数据
            this.createTimelineData(row)
          })
        }).catch(err => {
          this.promptWin = true;
          this.prompt = '查询审批流程数据失败，请稍后重试';
        })
      }else{
        this.cfmRec(row,index)
      }
    },
    // 创建时间线数据
    createTimelineData(fileRow) {
      this.timelineData = [];

      // 1. 添加发起节点（从V_D_FLOW_APPLOG中找到LOGTY='F'的记录）
      // 1. 添加发起节点（从V_D_FLOW_APPLOG中找到LOGTY='F'且ADDDTTM最新的记录）
      const startLogs = this.approvalLogs.filter(log => log.LOGTY === 'F');
      const startLog = startLogs.length > 0 ? startLogs.reduce((latest, current) => {
        return new Date(current.ADDDTTM) > new Date(latest.ADDDTTM) ? current : latest}, startLogs[0]): null;
      if (startLog) {
        this.timelineData.push({
          type: 'start',
          timestamp: startLog.ADDDTTM,
          title: startLog.ADDUSER,
          content: `${startLog.EMPNM} 发起了文件审批`,
          remark: startLog.RMK || '',
          status: 'success',
          icon: 'el-icon-upload',
          data: startLog,

        });
      }

      // 2. 处理审批用户数据（直接从d_flow_appuser获取状态）
      if (this.approvalUsers && this.approvalUsers.length > 0) {
        const sortedUsers = [...this.approvalUsers].sort((a, b) => a.APPSORT - b.APPSORT);

        // 分离审核人和抄送人
        const approvers = sortedUsers.filter(user => user.ISCC === '0');
        const ccUsers = sortedUsers.filter(user => user.ISCC === '1');
        console.log(approvers,'..approver')
        // 处理审核人节点
        approvers.forEach(user => {
          let nodeStatus = 'info';
          let nodeIcon = 'el-icon-time';
          let nodeContent = '';

          // 根据d_flow_appuser的STFG字段确定状态
          if (user.STFG === 'Y') {
            nodeStatus = 'success';
            nodeIcon = 'el-icon-check';
            nodeContent = '已审批通过';
          } else if (user.STFG === 'P') {
            nodeStatus = 'warning';
            nodeIcon = 'el-icon-time';
            nodeContent = '待审批';
          } else {
            // STFG为'N'或其他值都显示为未开始
            nodeStatus = 'info';
            nodeIcon = 'el-icon-time';
            nodeContent = '未开始';
          }

          // 添加审核人节点
          this.timelineData.push({
            type: 'approval',
            timestamp: user.APPDTTM || '',
            title: `审核人：${user.EMPNM}`,
            content: nodeContent,
            status: nodeStatus,
            icon: nodeIcon,
            user: user,
            remark: user.RMK || '',
            chkrmk:user.CHKRMK
          });
        })

        // 处理抄送人节点（合并为一个节点）
        if (ccUsers.length > 0) {
          const ccNames = ccUsers.map(user => user.EMPNM);
          let ccStatus = 'info'; // 默认状态
          let ccContent = '';
          let latestCCTimestamp = '';

          // 检查所有审批节点是否都已通过（状态为Y）
          const allApprovalsPassed = approvers.every(user => user.STFG === 'Y');

          if (allApprovalsPassed) {
            ccStatus = 'success';
            ccContent = '已接收';
          } else {
            ccStatus = 'info';
            ccContent = ''; // 不显示状态
          }

          // 取最新的抄送时间
          ccUsers.forEach(user => {
            if (user.APPDTTM && (!latestCCTimestamp || new Date(user.APPDTTM) > new Date(latestCCTimestamp))) {
              latestCCTimestamp = user.APPDTTM;
            }
          });

          // 添加合并的抄送人节点
          this.timelineData.push({
            type: 'cc',
            timestamp: latestCCTimestamp,
            title: `抄送人：${ccNames.join('、')}`,
            content: ccContent,
            status: ccStatus,
            icon: 'el-icon-s-promotion',
            users: ccUsers,
            remark: '',

          });
        }
      }

      // 3. 根据当前状态添加最终节点
      if (fileRow.STFG === 'Y') {
        this.timelineData.push({
          type: 'end',
          timestamp: '',
          title: '审批完成',
          content: '所有审批已完成，文件审核通过',
          status: 'success',
          icon: 'el-icon-circle-check'
        });
      } else if (fileRow.STFG === 'R') {
        this.timelineData.push({
          type: 'end',
          timestamp: '',
          title: '审批结束',
          content: '审批被驳回，流程结束',
          status: 'danger',
          icon: 'el-icon-circle-close'
        });
      }

    },
    // 定时刷新
    reFresh(){
      // 每隔30分钟刷新一次
      let  timer = setInterval(() => {
        setTimeout(()=>{
          this.waitList()
        }, 0)
      }, 60000*30)

    },

    tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
      row.index =rowIndex
      // 1、未开始：灰色  2、进行中：蓝色  3、逾期：黄色  4、已完成：绿色  5、终止：黑色
      if (row['STFG']=='NO' ){  //未开始
        return 'gray-row';
      }else if (row['STFG'] =='PEND' &&row['ISOVER']=='N'){
        return 'blue-row';
      }else if (row['STFG'] =='OVER' ||row['ISOVER']=='Y' ){
        return 'yellow-row';
      }else if (row['STFG'] =='OK' ){
        return 'green-row';
      }else if (row['STFG'] =='END' ){
        return 'black-row';
      }
    },
    //单元格样式
    cellStyle({row,column}){
      if (column.property=='PCT' ){
        return {background:'linear-gradient(to right,#2e9bcfcc 0%,#4fcfd5cc '+row.PCT+'%'+',transparent 0%) !important',textAlign:'center',padding:'2px'}
      }else{
        return {padding:'2px'}
      }
    },
    customColorMethod(val) {
      if (val =='NO' ||val=='PEND') { //未开始，进行中
        return 'info';
      } else if (val =='OK') {
        return 'success';
      } else {
        return 'danger';
      }
    },
    workChart(){
      let that =this
      this.invInstance = this.$echarts.init(document.getElementById("workId"));
      let option = {
        color: ['#388'],
        grid:{
          //与绝对定位相似，top，left，right，bottom 设定是根据上级盒子宽高来计算
          top:"10px",
          left:"35px",
          right:"5px",
          bottom:"20px"
        },
        title:{
          text:'',
        },
        tooltip : {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          }
        },
        xAxis : [
          {
            type : 'category',
            data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            axisTick: {
              alignWithLabel: true, // 图形于标题居中
            },

          }
        ],
        yAxis : [
          {
            type : 'value',
            axisLabel: {
              show:true,
              formatter: '{value} 条' ,
              textStyle: {
                fontFamily:'微软雅黑',
                color: "#380",
                fontSize: '10',
                fontWeight:'bold',
              },
            }
          }
        ],
        series : [
          {
            name:'每月待完成数',
            type:'line',
            stack: 'Total',
            symbolSize: 8, //折线点的大小
            data: this.mthTask  ,
          }
        ]
      }
      that.invInstance.setOption(option,true);
    } ,
    stfgSet(row,index){
      this.stfgWin =true
      this.v_row=JSON.parse(JSON.stringify(row))
      this.v_index=index
    },

    stfgSure(){
      let vm =this
      this.$confirm('你确定要变更状态吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        customClass:'messageBox',
        showClose:false,
        closeOnClickModal:false,
        closeOnPressEscape:false,
        type:'info',
      }).then(()=>{
        let v_cond =' set stfg=\''+this.v_radio+'\',actdttm=\''+getDate('full')+'\''
        this.$axios({
          method: 'post',
          url: 'xuper_auth/updateRe',
          data: {p_key:'idseq',p_value:this.v_row['IDSEQ'], p_table:'bs_plan',p_cond: v_cond},
        }).then(res=>{
          if (res.code=='200') {
            //A.STFG,'NO','未开始','PEND','进行中','OK','已完成','OVER','逾期','未开始') STFGNM,
            let v_stfg =this.v_radio=='NO'?'未开始':this.v_radio=='PEND'?'进行中':this.v_radio=='OK'?'已完成':'逾期'
            this.tabData.splice(this.v_index,1,Object.assign(this.v_row,{STFG:this.v_radio,ACTDTTM:getDate('full'),STFGNM:v_stfg}) )
            this.stfgWin =false
          }else{
            this.promptWin =true
            this.prompt =res.result
          }
        })
      }).catch(()=>{})

    },

    //图片预览
    imgPreview(path){
      if (path &&path.lastIndexOf('.pdf')>-1){
        let routeUrl = this.$router.resolve({
          path: '/fullPreview',
          query: {fileUrl: path},
        });
        window.open(routeUrl.href, '_blank');
      }
    },

    tabClick(val){
      this.tabitem =val
      if (val =='four'){
        this.$axios({
          method: 'post',
          url: 'xuper_auth/getBaseData',
          data: {p_key:'IDSEQ', p_value:this.v_cfmRow['IDSEQ'] , p_table:'V_SYS_FLOW_APPLOG',p_cond:' order by appdttm '},
        }).then(res=>{
          this.logData =res.result
        })
      }
    },
    itemClick(val){
      this.actitem =val
      if (val =='two'){
        this.t_loading =true
        this.$axios({
          method: 'post',
          url: 'xuper_auth/getBaseData',
          data: {p_key:'EMPNO', p_value:this.v_username,p_key2:'corpid',p_value2:this.v_corpid, p_table:'V_APPROVE_MY',p_cond:' order by appdttm desc'},
        }).then(res=>{
          this.okAll =res.result
          this.okNum=this.okAll.length
          this.initPage()
          this.$nextTick(()=>{
            this.t_loading=false
            this.$refs['refcfm'].doLayout()
          })
        })
      }else if (val =='three'){
        if (this.$refs.refwait){
          this.ccNum =this.$refs.refwait.v_rowcnt
        }
      }
    },

    repShow(row){
      this.repWin =true
      this.repUrl =this.$store.state.repUrl+ row['REPURL']+'&p_corpid='+this.v_corpid+'&p_idno='+row['IDNO']
    },
    //确定 驳回
    rmkExit(){
      if (this.v_rmk){
        //select * from v_SYS_flow_appuser where idseq=460644 and iscc='0' ;
        //1、先判断当前用户是否有驳回权限 且 得到审批的顺序
        this.$axios({
          method: 'post',
          url: 'xuper_auth/getBaseData',
          data: {p_key:'idseq', p_value:this.appRow['IDSEQ'],p_cond:' and iscc=\'0\' and userno=\''+this.v_username+'\'', p_table:'v_SYS_flow_appuser'},
        }).then(res=>{
          let v_sort =res.result[0]['APPSORT']
          //2、判断下个审批节点是否 有审批过
          this.$axios({
            method: 'post',
            url: 'xuper_auth/getBaseData',
            data: {p_key:'idseq', p_value:this.appRow['IDSEQ'],p_cond:' and iscc=\'0\' and stfg=\'Y\' and appsort>'+v_sort, p_table:'v_SYS_flow_appuser'},
          }).then(res=>{
            let v_len =res.result.length
            if (v_len >0){
              this.promptWin =true
              this.prompt ='下个节点已审批，不能驳回'
            }else {
              this.$confirm('你确定要驳回此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
              }).then(()=>{
                let v_cond =''
                if (this.v_cfmRow['TABNM'] =='RD_MAT') {
                  v_cond =' set ordstfg=\'N\',REDORMK=\''+this.v_rmk+'\',appuser=null'
                }else{
                  v_cond =' set stfg=\'N\',REDORMK=\''+this.v_rmk+'\',appuser=null'
                }
                this.v_commit =true
                this.$axios({
                  method: 'post',
                  url: 'xuper_auth/updateRec',
                  data: {p_key:'idseq',p_value:this.v_cfmRow['IDSEQ'],p_table:this.v_cfmRow['TABNM'],p_cond: v_cond},
                }).then(res=>{
                  if (res.code=='200') {
                    this.taskData.splice(this.v_cfmindex,1)
                    this.appWin =false
                    //再更新预审批流 状态为P的 变更为N
                    this.$axios({
                      method: 'post',
                      url: 'xuper_auth/updateRec',
                      data: {p_key:'idseq',p_value:this.v_cfmRow['IDSEQ'], p_table:'SYS_flow_appuser',p_cond: ' SET STFG=\'N\'',p_where:' and iscc=\'0\' '},
                    }).then(res=>{
                      let v_obj={IDSEQ:this.v_cfmRow['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,STFG:'Y',LOGTY:'R',APPDTTM:getDate('full'),RMK:'审批人 驳回',CHKRMK:this.v_rmk}
                      // 增加一条日志
                      this.$axios({
                        method: 'post',
                        url: 'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                      }).then(res=>{
                      })
                      this.v_commit =false
                    })
                  }else{
                    this.promptWin =true
                    this.prompt =res.result
                  }
                })
              }).catch(err=>{})
            }
          })
        })
      }else{
        this.promptWin =true
        this.prompt ='请填写驳回原因'
      }
    },
    redoExit(){
      if (this.v_rmk){
        this.$confirm('你确定要驳回此记录吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText:'取消',
          customClass:'messageBox',
          showClose:false,
          closeOnClickModal:false,
          closeOnPressEscape:false,
          type:'info',
        }).then(()=>{
          let v_cond =''
          if (this.v_cfmRow['TABNM'] =='RD_MAT') {
            v_cond =' set ordstfg=\'N\',REDORMK=\''+this.v_rmk+'\',appuser=null'
          }else{
            v_cond =' set stfg=\'N\',REDORMK=\''+this.v_rmk+'\',appuser=null'
          }
          this.$axios({
            method: 'post',
            url: 'xuper_auth/updateRec',
            data: {p_key:'idseq',p_value:this.v_cfmRow['IDSEQ'],p_table:this.v_cfmRow['TABNM'],p_cond: v_cond},
          }).then(res=>{
            if (res.code=='200') {
              this.taskData.splice(this.v_cfmindex,1)
              this.rmkWin =false

            }else{
              this.promptWin =true
              this.prompt =res.result
            }
          })
        }).catch(err=>{})
      }else{
        this.promptWin =true
        this.prompt ='请填写驳回原因'
      }
    },
    //确定 审核
    rmkOk(){
      this.$confirm('你确定要同意此记录吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        customClass:'messageBox',
        showClose:false,
        closeOnClickModal:false,
        closeOnPressEscape:false,
        type:'info',
      }).then(()=>{
        this.loadWin =true
        let v_cond =''
        if (this.v_cfmRow['TABNM'] =='RD_MAT') {
          v_cond =' set ordstfg=\'Y\' ,chkuser=\''+this.v_usernm +'\',chkdttm=\''+getDate('full')+'\''
        }else if (this.v_cfmRow['TABNM'] =='ORD_EXIT') { //订单异常关闭
          v_cond =' set ENDuser=\''+this.v_usernm +'\',ENDdttm=\''+getDate('full')+'\''
        }else{
          v_cond =' set stfg=\'Y\' ,chkuser=\''+this.v_usernm +'\',chkdttm=\''+getDate('full')+'\''
        }
        this.v_commit =true
        handleApproval({
          businessId: this.v_cfmRow['IDSEQ'],
          approverId: this.v_username,
          approverName: this.v_usernm,
          action: 'approve',
          comment: this.v_rmk,
          component: this,
          DIRNM: this.v_cfmRow['IDTY'],
          CNAME: this.v_cfmRow['TITLE'],
          FRUSER: this.v_cfmRow['ADDUSER'],
          axios: this.$axios,
          EMPNO: this.v_username,
          tableName:this.v_cfmRow['TABNM']=='ORD_EXIT'?'ORD':this.v_cfmRow['TABNM'],
          UPD_COND:v_cond,
          CHKRMK:this.v_rmk,
        }).then(() => {
          // 审批完成后的处理
          this.taskData.splice(this.v_cfmindex,1)
          this.appWin =false
          this.v_commit=false
          this.loadWin =false
        }).catch((error) => {
          this.promptWin =true
          this.prompt = '审批操作失败，请联系管理员'
        })

      }).catch(err=>{})
    },
    checkOk(){
      this.$confirm('你确定要通过吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        customClass:'messageBox',
        showClose:false,
        closeOnClickModal:false,
        closeOnPressEscape:false,
        type:'info',
      }).then(()=>{
        let v_cond =''
        if (this.v_cfmRow['TABNM'] =='RD_MAT') {
          v_cond =' set ordstfg=\'Y\' ,chkuser=\''+this.v_usernm +'\',chkdttm=\''+getDate('full')+'\''
        }else{
          v_cond =' set stfg=\'Y\' ,chkuser=\''+this.v_usernm +'\',chkdttm=\''+getDate('full')+'\''
        }
        this.$axios({
          method: 'post',
          url: 'xuper_auth/updateRec',
          data: {p_key:'idseq',p_value:this.v_cfmRow['IDSEQ'],p_table:this.v_cfmRow['TABNM'],p_cond: v_cond},
        }).then(res=>{
          if (res.code=='200') {
            this.taskData.splice(this.v_cfmindex,1)
            this.rmkWin =false
            if ( this.v_cfmRow['TABNM']=='QC_CHG'){ //4M 变更通知单
              this.$axios({
                method: 'post',
                url: '/xuper_oss/call_package',
                data: {p_corpid:this.v_corpid,p_idseq:this.v_cfmRow['IDSEQ'],p_action:'BOM_CHANGE#',p_cond: this.v_cfmRow['TABNM']},
              })
            }
            // oss/call_package
          }else{
            this.promptWin =true
            this.prompt =res.result
          }
        })
      }).catch(err=>{})
    },
    //审核
    cfmRec(row,index){
      if (row['SEQ']==1){
        this.v_rmk =''
        this.rmkWin =true
        this.v_cfmRow = JSON.parse(JSON.stringify(row))
        this.v_cfmindex=index
      }else{
        let v_text=''
        if (row['TY']=='RECEIVE'){
          v_text ='签收'
        }else if (row['TY']=='CONFIRM'){
          v_text ='确认'
        }else{
          v_text ='审核'
        }
        this.$confirm('你确定要'+v_text+'此记录吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText:'取消',
          customClass:'messageBox',
          showClose:false,
          closeOnClickModal:false,
          closeOnPressEscape:false,
          type:'info',
        }).then(()=>{
          if (row['TY']=='RECEIVE'){ //待签收
            let v_cond =' set ischk=\'Y\',chkdttm=\''+getDate('full')+'\''
            this.$axios({
              method: 'post',
              url: 'xuper_auth/updateRec',
              data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row['APPDTTM'],p_table:row['TABNM'],p_cond: v_cond},
            }).then(res=>{
              if (res.code=='200') {
                this.taskData.splice(index,1)
              }else{
                this.promptWin =true
                this.prompt =res.result
              }
            })
          }else if (row['TY']=='CONFIRM'){ //待确认
            let v_cond =''
            if (row['TELNO1']==this.v_username && !row['NODTTM1']){
              v_cond =' set nodttm1= \''+getDate('full')+'\''
            }else if (row['TELNO2']==this.v_username && !row['NODTTM2']){
              v_cond =' set nodttm2= \''+getDate('full')+'\''
            }else if (row['TELNO3']==this.v_username && !row['NODTTM3']){
              v_cond =' set nodttm3= \''+getDate('full')+'\''
            }else if (row['TELNO4']==this.v_username && !row['NODTTM4']){
              v_cond =' set nodttm4= \''+getDate('full')+'\''
            }else if (row['TELNO5']==this.v_username && !row['NODTTM5']){
              v_cond =' set nodttm5= \''+getDate('full')+'\''
            }
            this.$axios({
              method: 'post',
              url: 'xuper_auth/updateRec',
              data: {p_key:'idseq',p_value:row.IDSEQ, p_table:row['TABNM'],p_cond: v_cond},
            }).then(res=>{
              if (res.code=='200') {
                this.taskData.splice(index,1)
              }else{
                this.promptWin =true
                this.prompt =res.result
              }
            })
          } else{  //待审核
            let v_cond =' set stfg=\'Y\' ,chkuser=\''+this.v_usernm +'\',chkdttm=\''+getDate('full')+'\''
            this.$axios({
              method: 'post',
              url: 'xuper_auth/updateRec',
              data: {p_key:'idseq',p_value:row.IDSEQ,p_table:row['TABNM'],p_cond: v_cond},
            }).then(res=>{
              if (res.code=='200') {
                this.taskData.splice(index,1)
              }else{
                this.promptWin =true
                this.prompt =res.result
              }
            })
          }
        }).catch(()=>{})
      }
    },
    formQry(){
      let v_cond =' and lower(frmnm) like \'%'+this.v_formnm.toLowerCase()+'%\''
      this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'userno',
        p_value: this.v_username,
        p_key2: 'corpid',
        p_value2: this.v_corpid,
        p_table: 'V_userlog',
        p_cond: v_cond +' order by logdttm desc'
      }).then(res => {
        this.loveItem = res.result
      })
    },
    getOrdList(){ 
      
      this.ordData =[]
      if (this.v_roleid!=='006') {
        this.w_loading =true
        let v_cond ='and wkstfg!=\'OK\' and TASKTY=\'414831\''
        this.$axios({
          method: 'post',
          url:'xuper_auth/getPlanTreeData',
          data: {p_key:'corpid',p_value:this.v_corpid,p_table:'V_bs_plan',p_cond:v_cond+' order by lvl desc' },
        }).then(res=>{
          if (res.code==='200'){
            this.ordData =res.result
            this.w_loading =false
          }else{
            this.promptWin=true
            this.prompt=res.result
          }
        })
      }
    },
    // 跟进明细
    workList(v_idno){

      let v_rep ='job_plan.cpt'
      this.repWin =true
      this.repUrl =this.$store.state.repUrl+v_rep +'&p_corpid='+this.v_corpid+'&p_idno=' +v_idno
    },
    getWkList(){
      this.d_loading =true
      this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'corpid',
        p_value: this.v_corpid,
        p_table: 'V_bs_plan',
        p_cond:  ' and wkstfg!=\'OK\' order by todttm'
      }).then(res => {
        this.wkData = res.result
        this.d_loading =false
        if (this.wkData.length > 0) {
          this.$nextTick(() => {
            this.$refs.refwk.setCurrentRow(this.wkData[0])
          })
        }
      })
    },


    getRowKey(row){
      return row.index
    },

    initCal(){
      this.rmkArr=[]
      this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'userno',
        p_value: this.v_username,
        p_key2: 'corpid',
        p_value2: this.v_corpid,
        p_table: 'V_hr_msg',
        p_cond: ' and ty=\'WORK\' and rmk is not null'
      }).then(res => {
        this.rmkArr = res.result
      })

    },

    //改变月份
    changeDate(val){
      let dateArr =val.split('-')
      this.$refs.refcal.render(dateArr[0], dateArr[1]);
    },
    //模块点击事件
    topClick(val){
      this.$router.push({
        path: val,
      }, () => {})
    },

    // 接收服务器推送的信息
    pushBom(){
      var that =this
      if("WebSocket" in window){
        console.log('websocket 初始化' )
        var ws =new WebSocket(that.$store.state.wsUrl+that.v_username)
        ws.onmessage =function(evt){
          var receive_msg =evt.data
          console.log('webSocket收到消息:' +receive_msg)
          if (receive_msg=='invCfm'){ //发票单
            console.log('发票单保存时推送的通知... ')
          }else if (receive_msg=='sup_save'){ //供应商
            console.log('供应商保存时推送的通知... ')
          } else if (receive_msg=='poord_save'){ //采购订单
            console.log('采购订单保存时推送的通知... ')
            that.waitList()
          }
        }
        ws.onerror = (err) => {
          console.error("WebSocket 错误:", err)
        }
        ws.onclose = () => {
          console.error("WebSocket 已断开")
        }
      }else{
        this.promptWin =true
        this.prompt ='你的浏览器不支持websocket'
      }
    },
    changePage(index){
      var _start = ( index - 1 ) * this.pageSize;
      var _end = index * this.pageSize;
      this.okData = this.okAll.slice(_start,_end);
    },
    initPage(){
      this.dataCount =this.okAll.length //总条数
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.okAll.length < this.pageSize){
        this.okData = this.okAll
      }else{
        this.okData =this.okAll.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
      }
    },
    changePage2(index){
      var _start = ( index - 1 ) * this.pageSize;
      var _end = index * this.pageSize;
      this.ccData = this.ccAll.slice(_start,_end);
    },
    initPage2(){
      this.ccCount =this.ccAll.length //总条数
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.ccAll.length < this.pageSize){
        this.ccData = this.ccAll
      }else{
        this.ccData =this.ccAll.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
      }
    },
    //待审核列表
    waitList(){
      this.v_loading =true
      //待签收
      let v_chk =' or (ty=\'RECEIVE\' and chkdttm is null and appuser=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and appdttm is null and telno1=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and chkdttm is null and telno2=\''+this.v_username+'\') '
      v_chk =v_chk+' or (ty=\'CONFIRM\' and ((nodttm1 is null and telno1=\''+this.v_username+'\') or (nodttm2 is null and telno2=\''+this.v_username+'\') or (nodttm3 is null and telno3=\''+this.v_username+'\') or (nodttm4 is null and telno4=\''+this.v_username+'\') or (nodttm5 is null and telno5=\''+this.v_username+'\')))'
      let v_cond ='select * from V_WAIT_CONFIRM a where a.corpid=\''+this.v_corpid+'\' and ((ty=\'FREE\')'+v_chk+' OR exists(select null from V_CHKUSER where fruser is null and chkuser1=\''+this.v_username+'\' and ty=a.ty AND TY!=\'FINFEE\') or exists(select null from V_FLOW_CFM where idseq=a.idseq and userno=\''+this.v_username+'\') )'
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getFreeData',
        data: {p_cond: v_cond +' order by seq,idty,dttm desc'},
      }).then(res=>{
        this.taskData=res.result

        this.$nextTick(()=>{
          this.$refs['reftask'].doLayout()
          this.v_loading=false
        })
      })
    },

    // 我的最爱
    freshLove(){
      // 用户最近访问表单
      this.$axios.post('xuper_auth/getBaseData', {
        p_key: 'userno',
        p_value: this.v_username,
        p_key2: 'corpid',
        p_value2: this.v_corpid,
        p_table: 'v_userlog',
        p_cond: ' order by logdttm desc'
      }).then(res => {
        this.loveItem = res.result
      })

    },
    //字段列表
    async getTabField(){
      this.itmCol=[]
      this.taskCol=[]
      this.wkCol=[]
      this.$axios.post(this.v_url,{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'400038',p_key2:'lstseq',p_value2:'2523', p_cond: ' order by sortby,lstseq' }).then(res => {
        res.result.map(item => {
          this.itmCol.push({ //向数组的开头 添加序列号
            title: this.v_lang=='CN'?item.title:this.v_lang=='EN'?item.FLDEN:this.v_lang=='YN'?item.FLDYN:item.title,
            key: item.key,
            align: item.align,
            width: item.width,
            thide:item.THIDE,
            fhide:item.FHIDE,
            edcss:item.EDCSS,
            disabled:item.DISABLED,
            dotnum:item.DOTNUM,
            sortable:item.SORTABLE,
          })
        })
      })
      this.$axios.post(this.v_url,{p_table: 'v_sys_form_fld', p_key:'idseq', p_value:'400038', p_key2:'lstseq', p_value2:'2502', p_cond: ' order by sortby,lstseq' }).then((res) => {
        res.result.map(item => {
          this.taskCol.push({ //向数组的开头 添加序列号
            title: this.v_lang=='CN'?item.title:this.v_lang=='EN'?item.FLDEN:this.v_lang=='YN'?item.FLDYN:item.title,
            key: item.key,
            align: item.align,
            width: item.width,
            thide:item.THIDE,
            fhide:item.FHIDE,
            edcss:item.EDCSS,
            disabled:item.DISABLED,
            dotnum:item.DOTNUM,
            sortable:item.SORTABLE,
          })
        })
      })
      this.$axios.post(this.v_url,{p_table: 'v_sys_form_fld',p_key:'idseq', p_value: '407458', p_key2:'lstseq', p_value2:'2', p_cond: ' order by sortby,lstseq' }).then((res) => {
        res.result.map(item => {
          this.wkCol.push({ //向数组的开头 添加序列号
            title: this.v_lang=='CN'?item.title:this.v_lang=='EN'?item.FLDEN:this.v_lang=='YN'?item.FLDYN:item.title,
            key: item.key,
            align: item.align,
            width: item.width,
            thide:item.THIDE,
            fhide:item.FHIDE,
            edcss:item.EDCSS,
            disabled:item.DISABLED,
            dotnum:item.DOTNUM,
            sortable:item.SORTABLE,
          })

        })
      })
      getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407458','lstseq','7','','',' order by sortby,itmseq').then((res) => {
        for (let k=0; k<res.result.length; k++){
          this.ordCol.push({ //向数组的开头 添加序列号
            title: res.result[k].title,
            key: res.result[k].key.toLowerCase(),
            align: res.result[k].align,
            width: res.result[k].width,
            thide:res.result[k].THIDE,
            fhide:res.result[k].FHIDE,
            edcss:res.result[k].EDCSS,
            disabled:res.result[k].DISABLED,
            dotnum:res.result[k].DOTNUM,
            sortable:res.result[k].SORTABLE,
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
// .el-timeline-item__icon {
//     font-size: 24px;  /* 调整为目标尺寸 */
// }

.custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
  border-color: rgb(184, 181, 181);
  border-width: 1px;
}
.el-table .gray-row  {
  color: #808080;
}
.el-table .blue-row  {
  color: blue;
}
.el-table .yellow-row  {
  color: red;
}.el-table .green-row  {
   color: green;
 }.el-table .black-row  {
    color: black;
  }
.el-table__body {
  width: 100%;
  // 使表格兼容safari，不错位
  table-layout: fixed !important;
}
.home-content-layout{
  background-color: white;
  width: 100%;
  height:98%;
  max-height: 98%;
  max-height:-webkit-calc(100% - 11px);
  max-height:-moz-calc(100% - 11px);
  max-height: calc(100% - 11px);
}
.small-table .ivu-table-cell {
  padding: 6px;
}
.small-table td {
  height: 0px;
}
.small-table thead{
  height: 15px;
  color:rgb(128,128, 128);
  font-size:12px;
}
.ivu-table-row-highlight td{
  background-color: #9fcaf887 !important;
}

.el-tree-node.is-current > .el-tree-node__content {
  background-color: #9fcaf887 !important;
  color:rgb(30, 44, 90);
}
.el-tree-node__content:hover {
  background-color: #e7f0f887;
}
.tree-scroll{
  width :180px;
  border: 1px solid #4e4545;  //#f5dbdb
  height: 100%;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color :#3d77eb
}
.el-checkbox__input.is-disabled+span.el-checkbox__label{
  color:#3d77eb
}

.ivu-modal-content{
  height: auto !important;
  overflow-y: auto;
}


.el-table__body tr.current-row > td {
  background-color: #F1e1ff !important;
}
.el-table::before {
  background-color: #dfdedd;
}

.item-width  {
  width: 48%;
  height:20px !important;
}
.el-table {
  th {
    padding: 0 ;
  }
  th.gutter {
    display: table-cell !important
  }
  thead{
    height: 15px !important;
    color:rgb(128,128, 128);
    font-size:12px;
  }
  td {
    padding: 3px ;
    font-size:11px;
  }
}
.el-dialog__body{
  padding: 10px;
}
.el-dialog__header{
  padding: 0px;
}
.el-dialog__footer{
  padding: 5px;
  border-top:1px solid #ccc;
}
</style>
<style scoped lang="less">
.div-width{
  width: calc(100% - 0px);

}
.line-img{
  margin-right:6px;
  min-width:110px;
  height:90px;
  text-align:center;
  vertical-align:middle;
  display:inline-block;
}
.line-img:hover{
  background:#c7daec ;
  color:red !important;
}
.active {
  color: #389;
  border-bottom:3px solid #cc0000;
  margin-right:2px;
}
.oneMenu{
  display:flex;
  flex-direction:column;
  line-height:25px;
  background:white;
  margin-top:3px;
  font-size:13px;
  font-weight: 600;
}
.oneMenu:hover{
  cursor: pointer;
  color:#cc0000;
  background:#f7f8f9;
  font-weight:700;
}
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 1px auto !important;
    height: 90%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
/* 操作日志边框样式 */
.log-success {
  border-left-color: #67c23a !important;
}

.log-danger {
  border-left-color: #f56c6c !important;
}

.log-warning {
  border-left-color: #e6a23c !important;
}

.log-info {
  border-left-color: #909399 !important;
}
/* 新增：角色类型样式 */
.role-type {
  font-size: 12px;
  font-weight: 500;
  color: #909399;
  margin-bottom: 4px;
}
.role-name {
  font-size: 14px;
  font-weight: 600;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
}

.status-text.success {
  color: #27ae60;
}

.status-text.warning {
  color: #f39c12;
}

.status-text.danger {
  color: #e74c3c;
}

.timeline-time {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  font-weight:600;
  margin-right:5px;
}

.progress-info {
  margin-top: 8px;
}

.progress-text {
  color: #409EFF;
  font-size: 14px;
  margin-right: 8px;
}

.progress-detail {
  color: #909399;
  font-size: 13px;
}
.custom-timeline {
  position: relative;
  padding-left: 0 ;
  margin-top:15px;
}

.timeline-item {
  display: flex;
  margin-bottom: 34px;
  position: relative;
}

.timeline-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
  position: relative;
  width: 48px; /* 固定宽度确保对齐 */
}

.avatar-container {
  position: relative;
  z-index: 2;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 8px; /* 正方形圆角 */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  position: relative;
}

.avatar.success {
  background: #5dade2;
}

.avatar.warning {
  background: #f39c12;
}

.avatar.danger {
  background: #e74c3c;
}

.avatar.info {
  background: #95a5a6;
}

.avatar-text {
  font-size: 14px;
}

.status-check {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: #27ae60;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.status-check i {
  color: white;
  font-size: 12px;
}

/* 新增：审批中状态的...图标 */
.status-processing {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: #f39c12;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.status-processing i {
  color: white;
  font-size: 12px;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 48px; /* 从头像底部开始 */
  bottom: -34px; /* 延伸到下一个节点 */
  width: 2px;
  background: #e8e8e8;
  transform: translateX(-50%); /* 居中对齐 */
  z-index: 1;
}

.timeline-content {
  flex: 1;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.timeline-title {
  display: flex;
  flex-direction: column;
}
</style>
